/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface WaitForRtkActionArgs {
  timeoutS: number;
}

export interface WaitForRtkResultData {
}

export interface WaitForRtkActionStateData {
}

function createBaseWaitForRtkActionArgs(): WaitForRtkActionArgs {
  return { timeoutS: 0 };
}

export const WaitForRtkActionArgs = {
  encode(message: WaitForRtkActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeoutS !== 0) {
      writer.uint32(13).float(message.timeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForRtkActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForRtkActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WaitForRtkActionArgs {
    return { timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0 };
  },

  toJSON(message: WaitForRtkActionArgs): unknown {
    const obj: any = {};
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForRtkActionArgs>, I>>(base?: I): WaitForRtkActionArgs {
    return WaitForRtkActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForRtkActionArgs>, I>>(object: I): WaitForRtkActionArgs {
    const message = createBaseWaitForRtkActionArgs();
    message.timeoutS = object.timeoutS ?? 0;
    return message;
  },
};

function createBaseWaitForRtkResultData(): WaitForRtkResultData {
  return {};
}

export const WaitForRtkResultData = {
  encode(_: WaitForRtkResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForRtkResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForRtkResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WaitForRtkResultData {
    return {};
  },

  toJSON(_: WaitForRtkResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForRtkResultData>, I>>(base?: I): WaitForRtkResultData {
    return WaitForRtkResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForRtkResultData>, I>>(_: I): WaitForRtkResultData {
    const message = createBaseWaitForRtkResultData();
    return message;
  },
};

function createBaseWaitForRtkActionStateData(): WaitForRtkActionStateData {
  return {};
}

export const WaitForRtkActionStateData = {
  encode(_: WaitForRtkActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForRtkActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForRtkActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WaitForRtkActionStateData {
    return {};
  },

  toJSON(_: WaitForRtkActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForRtkActionStateData>, I>>(base?: I): WaitForRtkActionStateData {
    return WaitForRtkActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForRtkActionStateData>, I>>(_: I): WaitForRtkActionStateData {
    const message = createBaseWaitForRtkActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
